import {Component, EventEmitter, Output} from '@angular/core';
import {Router} from '@angular/router';
import {UtilService} from "library";

@Component({
  selector: 'app-sales-registered-application',
  templateUrl: './sales-registered-application.component.html',
})
export class SalesRegisteredApplicationComponent {
  @Output() nextStepEvent = new EventEmitter();

  constructor(private utilService: UtilService,
              private router: Router) {
    this.utilService.disablePageLoading();
  }

  goToHome() {
    this.router.navigate(['/inicio']);
  }
}